import { DateTime } from 'luxon'

const TimeAgo = (date) => {
  return DateTime.fromISO(date).toRelative()
}

export default TimeAgo


// WEBPACK FOOTER //
// ./src/Lib/TimeAgo.js